import React from 'react';
import clsx from 'clsx';
import ButtonSection from './ButtonSection';
import ListItemSection from './ListItemSection';
import MediaDesktop, { MediaMobile } from './MediaSection';
import DisclaimerSection from './DisclaimerSection';
import HeadingAndDescriptionSection from './HeadingAndDescriptionSection';
import { PhotoAndTextCardFieldsFragment } from '../../../@types/generated';
import SlideIn from '../Transitions/SlideIn';

type Props = {
  data: PhotoAndTextCardFieldsFragment;
};

const PhotoAndTextCard = ({ data }: Props) => {
  const hasMedia = Boolean(data.image || data.video);

  return (
    <div
      key={data.id}
      className="col-span-full w-full overflow-hidden md:col-span-12
        md:col-start-2 md:grid md:grid-cols-12"
    >
      <MediaMobile data={data} />
      {data.imagePosition === 'left' && <MediaDesktop data={data} />}
      <div
        className={clsx('w-full self-center md:pl-24 md:pr-24', {
          'col-span-6': hasMedia,
          'col-span-full md:col-span-12': !hasMedia,
          'md:col-start-7': hasMedia && data.imagePosition === 'left',
        })}
      >
        <SlideIn>
          <HeadingAndDescriptionSection data={data} />
          <ListItemSection data={data} />
        </SlideIn>
        <ButtonSection data={data} />
      </div>
      {data.imagePosition === 'right' && <MediaDesktop data={data} />}
      <DisclaimerSection data={data} />
    </div>
  );
};
export default PhotoAndTextCard;
